import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { NewProjectCard } from '../DashboardCard/NewProjectCard';
import { PastProjectCard } from '../DashboardCard/PastProjectCard';
import WeekSchedule from './WeekSchedule/';
import './DashboardFreelancerMain.css';
import ProfilePic from './../Header/profile-pic.svg';
import { ActiveCard } from '../DashboardCard/ActiveCard/ActiveCard';
import { removeEmptyObjects } from '../../shared/helpers';
import PortfolioCard from './PortfolioCard/PortfolioCard';
import ExperienceList from './ExperienceList/ExperienceList';

export const DashboardFreelancerMain = ({
  user,
  handleSelectTime,
  weekAvailability,
  advancedAvailability,
  handleToggleAvailability,
  handleToggleInstantBooking,
  handleAdvancedHours,
  handleAdvancedDay,
  handleAdvancedCheckbox,
  handleGoToProjectView,
  newProjects,
  pastProjects,
  activeProjects,
  instantBookInfo,
  handleUpdateInstantBookInfo,
  openPortfolioPopup,
  handleGoToFreelancerOnboarding,
  handleUpdateExperience,
}) => (
  <div className="row">
    <div className="col-12 header-freelancer">
      <div className="row">
        <div className="col-12">
          <div className="row bg-white pt-10 pb-3 mt-3 shadow-mid">
            <div className="col-12 col-lg-3 d-flex">
              <div
                className="header-freelancer-avatar align-self-center mx-auto"
                style={{
                  backgroundImage: `url(${user.avatar_url || ProfilePic})`,
                }}
              />
            </div>
            <div className="col-12 col-lg">
              <div className="row">
                <div className="col-12 col-lg-7">
                  <p className="text-center text-lg-left mt-4 mt-lg-0">
                    <span className="t-20 t-lg-36 text-darkgreen font-weight-normal user-name">
                      {user.name}
                    </span>
                    <a
                      className="text-dark-teal t-13 ml-2 edit-profile-button"
                      onClick={e =>
                        handleGoToFreelancerOnboarding(e, 'edit_profile')
                      }
                    >
                      Edit
                    </a>
                  </p>
                  {!isEmpty(user.bio) && (
                    <p className="t-13 text-gray mb-4 mb-lg-0 user-bio">
                      {user.bio}
                    </p>
                  )}
                </div>
                <div className="col d-xl-flex">
                  <div className="ml-auto d-xl-flex">
                    <p className="t-13">
                      <a href="/" className="user-email">
                        <i className="icon icon-message ml-2" />
                        <span>{user.email}</span>
                      </a>
                    </p>
                    {!isEmpty(user.phone_number) && (
                      <p className="t-13 ml-xl-4">
                        <i className="icon icon-phone text-primary ml-2" />
                        <span className="text-darkgreen user-phone-number">
                          {get(user, 'phone_number_ddi', '+1')}{' '}
                          {user.phone_number}
                        </span>
                      </p>
                    )}
                    {!isEmpty(user.state) && (
                      <p className="t-13 ml-xl-4">
                        <i className="icon icon-pin text-primary ml-2" />
                        <span className="text-darkgreen user-state">
                          {user.state}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <hr />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="row">
                    <div className="col-12 col-lg-7 mb-3">
                      <p className="mb-0">
                        <span className="t-13 font-weight-normal text-gray">
                          SKILLS
                        </span>
                        <a
                          className="text-dark-teal t-13 ml-2 edit-skills-button"
                          onClick={e =>
                            handleGoToFreelancerOnboarding(e, 'skills')
                          }
                        >
                          Edit
                        </a>
                      </p>
                      <div className="tag-list">
                        {map(user.formatted_skills, (skill, index) => (
                          <span
                            key={String(index)}
                            className="tag t-10 text-uppercase mr-4 mb-2 skill-tags-item"
                          >
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="col-12 col-lg-7">
                      <p className="mb-0">
                        <span className="t-13 font-weight-normal text-gray">
                          LANGUAGES
                        </span>
                        <a
                          className="text-dark-teal t-13 ml-2 edit-languages-button"
                          onClick={e =>
                            handleGoToFreelancerOnboarding(e, 'languages')
                          }
                        >
                          Edit
                        </a>
                      </p>
                      <div className="tag-lis languages-tags">
                        {map(
                          removeEmptyObjects([
                            ...filter(
                              user.fluent_languages,
                              lang => lang !== 'Other',
                            ),
                            user.other_languages,
                          ]),
                          (language, index) => (
                            <span
                              key={String(index)}
                              className="tag t-10 mr-4 mb-2 languages-tags-item"
                            >
                              {language}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <WeekSchedule
        user={user}
        handleSelectTime={handleSelectTime}
        weekAvailability={weekAvailability}
        advancedAvailability={advancedAvailability}
        handleToggleAvailability={handleToggleAvailability}
        handleToggleInstantBooking={handleToggleInstantBooking}
        handleAdvancedHours={handleAdvancedHours}
        handleAdvancedDay={handleAdvancedDay}
        handleAdvancedCheckbox={handleAdvancedCheckbox}
        instantBookInfo={instantBookInfo}
        handleUpdateInstantBookInfo={handleUpdateInstantBookInfo}
      />

      <div className="row">
        <PortfolioCard
          openPortfolioPopup={openPortfolioPopup}
          submissions={get(user, 'submissions', [])}
        />
      </div>

      <div className="row mb-5">
        <ExperienceList
          experiences={get(user, 'experiences', [])}
          handleGoToFreelancerOnboarding={handleGoToFreelancerOnboarding}
          handleUpdateExperience={handleUpdateExperience}
        />
      </div>

      {!isEmpty(newProjects) && (
        <div className="row mb-4">
          <div className="col-12 mt-1 mb-3">
            <p className="t-19">{`New Projects (${newProjects.length})`}</p>
          </div>
          <div className="col-12">
            <div className="row">
              {newProjects.map((project, index) => (
                <NewProjectCard
                  key={String(index)}
                  project={project}
                  handleGoToProjectView={handleGoToProjectView}
                  client={false}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {!isEmpty(activeProjects) && (
        <div className="row mb-4">
          <div className="col-12 mb-3">
            <p className="t-19">
              {`Active Projects (${activeProjects.length})`}
            </p>
          </div>
          <div className="col-12">
            <div className="row">
              {activeProjects.map((project, index) => (
                <ActiveCard
                  key={String(index)}
                  project={project}
                  handleGoToProjectView={handleGoToProjectView}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {!isEmpty(pastProjects) && (
        <div className="dashboard__element-half">
          <div className="dashboard__status-header">
            {`Past Projects (${pastProjects.length})`}
          </div>

          {pastProjects.map((project, index) => (
            <PastProjectCard
              key={String(index)}
              project={project}
              handleGoToProjectView={handleGoToProjectView}
              client={false}
            />
          ))}
        </div>
      )}
    </div>
  </div>
);

DashboardFreelancerMain.propTypes = {
  user: PropTypes.object,
  handleSelectTime: PropTypes.func,
  weekAvailability: PropTypes.array,
  advancedAvailability: PropTypes.array,
  handleToggleAvailability: PropTypes.func,
  handleToggleInstantBooking: PropTypes.func,
  handleAdvancedHours: PropTypes.func,
  handleAdvancedCheckbox: PropTypes.func,
  handleAdvancedDay: PropTypes.func,
  handleGoToProjectView: PropTypes.func,
  newProjects: PropTypes.array,
  pastProjects: PropTypes.array,
  activeProjects: PropTypes.array,
  instantBookInfo: PropTypes.array,
  handleUpdateInstantBookInfo: PropTypes.func,
  openPortfolioPopup: PropTypes.func,
  handleGoToFreelancerOnboarding: PropTypes.func,
  handleUpdateExperience: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/DashboardFreelancerMain.js